module.exports = {
  defaultLocale: 'en',
  locales: ['en', 'zh-sc', 'zh-tc', 'kr'],
  prerender: true,
  dbProject: 'TAB5 Teaser',
  analytics: {
    gtag: '',
    gtmId: 'GTM-TC2MLTL',
    optimizeId: '',
    hotjarId: '',
  },
  seo: {
    title: 'The Amazing Brentwood - Tower 5 - New Homes Coming Soon',
  },
  stage: {
    mobile: 320,
    tablet: 768,
    desktop: 1440,
  },
  mediaQuery: {
    tablet: 576,
    desktop: 992,
  },
};
